import { render } from "./ReportsIndex.vue?vue&type=template&id=01fc13b8&scoped=true"
import script from "./ReportsIndex.vue?vue&type=script&lang=js"
export * from "./ReportsIndex.vue?vue&type=script&lang=js"

import "./ReportsIndex.vue?vue&type=style&index=0&id=01fc13b8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fc13b8"]])

export default __exports__